/**
 * @file     phoneGateTtl.ts
 * @purpose  How long a phone-gate proof lives. Split from the token module so
 *           the browser can share the number without importing node:crypto.
 */
export const PHONE_GATE_TTL_MS = 20 * 60 * 1000;
